import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2368abda&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2368abda&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=2368abda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368abda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2368abda')) {
      api.createRecord('2368abda', component.options)
    } else {
      api.reload('2368abda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2368abda&scoped=true", function () {
      api.rerender('2368abda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/shopManager/index.vue"
export default component.exports